import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Button from "@mui/material/Button";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import "../../dashboard/style/createInventory.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Box from "@mui/material/Box";
import LayersIcon from "@mui/icons-material/Layers";

export default function MultipleInvoiceVoidModal(props) {
  const {
    open,
    handleClose,
    payment,
    onVoidThisInvoiceOnly,
    onVoidAllInvoices,
  } = props;

  const invoiceList = React.useMemo(() => {
    const toIdList = (value) => {
      if (Array.isArray(value)) return [...value]; 
      if (typeof value === "string" && value.trim().length) {
        return value
          .split(",")
          .map((id) => id.trim())
          .filter(Boolean);
      }
      return [];
    };

    const list = toIdList(payment?.multipleinvoices);
    const voidedIds = new Set(toIdList(payment?.voidedinvoices).map(String));

    return list
      .filter((id) => !voidedIds.has(String(id)))
      .sort((a, b) => Number(a) - Number(b));
  }, [payment]);

  const invoiceCount = invoiceList.length;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="void-multiple-invoice-title"
    >
      <DialogTitle id="void-multiple-invoice-title" style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: 10,
            backgroundColor: "#FDECD2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <WarningAmberOutlinedIcon style={{ color: "#E0A030" }} />
        </div>
        <div style={{ flexGrow: 1 }}>
          <Typography variant="h6" style={{ fontWeight: 700 }}>
            Void Payment
          </Typography>
          <Typography variant="body2" style={{ color: "rgba(0,0,0,0.6)", marginTop: 5, marginBottom: 10 }}>
            This payment is associated with {invoiceCount} invoices. Do you
            want to void the transaction for this invoice only or all{" "}
            {invoiceCount} invoices?
          </Typography>
        </div>
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 14,
            marginBottom: 8,
          }}
        >
          <div>
            <Typography variant="subtitle2" style={{ fontWeight: 700, display: "inline" }}>
              NO. OF INVOICES{" "}
            </Typography>
            <span
              style={{
                display: "inline-block",
                backgroundColor: "#E8F1FB",
                color: "#1976d2",
                borderRadius: 14,
                padding: "4px 14px",
                fontSize: 13,
                fontWeight: 700,
                marginLeft: 6,
                boxShadow: "0 1px 3px rgba(25, 118, 210, 0.25)",
              }}
            >
              {invoiceCount} {invoiceCount === 1 ? "Invoice" : "Invoices"}
            </span>
          </div>
        </div>
        {invoiceList.length > 0 && (
          <div
            style={{
              backgroundColor: "#F7F8FA",
              borderRadius: 8,
              padding: 16,
              marginBottom: 16,
            }}
          >
            <Typography variant="body2" style={{ fontWeight: "800px" }}>
              {invoiceList.join(", ")}
            </Typography>
          </div>
        )}

        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 8,
            backgroundColor: "#FDF3E3",
            borderRadius: 8,
            padding: "12px 14px",
            marginBottom: 20,
          }}
        >
          <InfoOutlinedIcon style={{ color: "#E0A030", fontSize: 18, marginTop: 2 }} />
          <Typography variant="body2" style={{ color: "#8A6D3B" }}>
            If you choose to void for all invoices, the transaction will be
            voided for all {invoiceCount} invoices and cannot be reversed.
          </Typography>
        </div>

        <div style={{ gap: 12, display: "flex", justifyContent: "flex-end" }}>
          <Button
            className="ai-btn ai-btn--ghost"
            onClick={handleClose}
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "#cea05f", color: "#fff", textTransform: "none", marginRight: "10px" }}
            onClick={onVoidThisInvoiceOnly}
          >
            Void for This Invoice Only
          </Button>
          <Button
            style={{ backgroundColor: "#cea05f", color: "#fff", textTransform: "none" }}
            onClick={onVoidAllInvoices}
          >
            Void for All {invoiceCount} Invoices
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}